/* 130R — convite "Qual é o seu carro?" (Tema 2, 19/10/2026, agente veiculo-motor).
   Pedido do Marcus: "um pop-up com a sugestão do cliente informar o veículo assim que aterrissa no site, seja numa página
   de compra ou qualquer outra, com a sugestão de que vai facilitar para ele navegar no site através dessa informação."

   QUEM VÊ: quem chega sem carro completo salvo (montadora, modelo, ano e motor, ou o chassi no lugar do motor).
     Carro salvo sem motor e sem chassi: o convite é para completar ("Falta o motor do seu HB20 2019").
     Carro salvo que não existe na lista da base (ex.: Azera 2004) e sem chassi: o convite é para corrigir (nada é apagado).
   ONDE NÃO APARECE: carrinho e checkout, conta do cliente, /pages/kits-por-carro (lá o carro é o 1º passo), página das
     oficinas (empresa, não tem "o carro"), em cima de outra janela (Meu carro, chassi, Avise-me, menu, gaveta do carrinho,
     filtros, mega menu, sugestões da busca, aviso de cookies) e para robôs. ?r130convite=0 desliga nesta aba.
   QUANDO: 8 s com a página visível ou a primeira rolagem de 1/3 da tela, o que vier primeiro; se a pessoa está digitando
     ou com outra janela aberta, espera (até 90 s). No máximo 1 vez por sessão; fechado, volta só depois de 7 dias.
   COMO (decisão do Marcus, 19/10/2026: no computador, cartão no canto que não interrompe):
     - computador (992 px ou mais): cartão no canto de baixo, à esquerda (snippets/r130-carro-convite.liquid);
     - celular: faixa embaixo, acima da barra do celular e da barra de compra, sem cobrir o conteúdo na chegada
       (orientação do Google sobre intersticiais).
     Nos dois, não rouba o foco; X, Esc e clique fora fecham. "Informar meu carro" abre a janela do "Meu carro" (mesmo
     formulário, com o motor; window.R130Garagem.abrir), onde o foco fica preso até fechar e depois volta.
   MEDIÇÃO (window.R130Medicao.emitir): carro_popup_exibido (formato "cartao" ou "faixa"), carro_popup_aceito (salvou o carro pelo convite) e
     carro_popup_fechado (com "como": x, esc, fora, agora_nao, remover); o carro_salvo continua vindo do r130-medicao.js.
   TEXTO: com o WhatsApp levando o carro (assets/r130-carro-wa.js, aprovado em 19/10/2026), o benefício principal vem
     primeiro: "o vendedor já recebe o carro e o motor" (atributos -wa do snippets/r130-carro-convite.liquid).
   TESTE: ?r130convite=teste deixa o navegador automatizado ver o convite nesta aba (as outras regras continuam). */
(function () {
  'use strict';
  if (window.R130Convite) return;
  var K_FECHADO = 'r130_carro_convite', K_SESSAO = 'r130_carro_convite_sessao', K_TESTE = 'r130_carro_convite_teste';
  var DIAS = 7, ESPERA_MS = 8000, ROLAGEM = 1 / 3, DESISTE_MS = 90000, COMPUTADOR = 992;
  var doc = document, html = doc.documentElement;

  function ssLer(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssGravar(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function lsLer(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsGravar(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function emitir(nome, campos) {
    try { if (window.R130Medicao && window.R130Medicao.emitir) window.R130Medicao.emitir(nome, campos); } catch (e) {}
  }

  var params;
  try { params = new URLSearchParams(location.search); } catch (e) { params = { get: function () { return null; } }; }
  if (params.get('r130convite') === 'teste') ssGravar(K_TESTE, '1');
  if (params.get('r130convite') === '0') return;
  var teste = ssLer(K_TESTE) === '1';

  function robo() {
    if (teste) return false;
    return !!navigator.webdriver || /bot\b|bot\/|crawl|spider|slurp|mediapartners|google-inspectiontool|googleother|bingpreview|yandex|baidu|duckduck|facebookexternalhit|lighthouse|pagespeed|headless|semrush|ahrefs|petal|bytespider|chatgpt|perplexity/i.test(navigator.userAgent || '');
  }
  function paginaBloqueada() {
    var p = location.pathname.replace(/\/+$/, '') || '/';
    var tpl = (doc.body && doc.body.getAttribute('data-template')) || '';
    var suf = (doc.body && doc.body.getAttribute('data-suffix')) || '';
    if (tpl === 'cart' || tpl === 'password' || tpl === 'gift_card' || /^customers/.test(tpl)) return true;
    if (tpl === 'page' && (suf === 'kits' || suf === 'oficinas')) return true;
    return /^\/(cart|checkout|checkouts|account|password|challenge|apps|tools)(\/|$)/.test(p)
      || /^\/pages\/(kits-por-carro|oficinas-e-lojas)$/.test(p);
  }
  function suprimido() {
    if (ssLer(K_SESSAO)) return true;
    var t = Number(lsLer(K_FECHADO) || 0);
    return t > 0 && Date.now() - t < DIAS * 24 * 3600 * 1000;
  }
  function garagem() { return window.R130Garagem || null; }
  var foraDaLista = null;   // carro salvo que não está na lista da base (conferido no início, pelo catálogo)
  function temChassi() { try { var v = JSON.parse(localStorage.getItem('r130_chassi') || 'null'); return !!(v && v.vin); } catch (e) { return false; } }
  function mesmoCarro(a, b) { return !!(a && b) && a.brand === b.brand && a.model === b.model && String(a.year) === String(b.year); }
  // {modo: 'novo'} | {modo: 'completar', carro} | {modo: 'corrigir', carro} | null (completo)
  function situacao() {
    var g = garagem();
    if (!g) return null;
    var c = g.carro();
    if (!c) return { modo: 'novo' };
    if (g.completo(c)) return foraDaLista && mesmoCarro(foraDaLista, c) && !temChassi() ? { modo: 'corrigir', carro: c } : null;
    return c.year ? { modo: 'completar', carro: c } : { modo: 'novo' };
  }

  function visivel(el) {
    if (!el) return false;
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || Number(cs.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 1 && r.height > 1;
  }
  var faixa = null;
  // Outra janela aberta (ou a pessoa ocupada): o convite espera.
  function ocupado() {
    var abertas = doc.querySelectorAll('dialog[open]');
    for (var i = 0; i < abertas.length; i++) if (abertas[i] !== faixa) return 'janela';
    if (doc.querySelector('#sidebarDrawer.is-open')) return 'filtros';
    if (/\b(r130-cart-travado|r130-gav-aberta|r130-cf-aberta|overflow-hidden)\b/.test(html.className)) return 'gaveta';
    if (doc.querySelector('[data-r130-mega-gatilho][aria-expanded="true"]')) return 'mega_menu';
    if (visivel(doc.getElementById('shopify-pc__banner')) || visivel(doc.querySelector('#shopify-pc__prefs__dialog'))) return 'cookies';
    var sug = doc.querySelectorAll('.r130-sug');
    for (var j = 0; j < sug.length; j++) if (!sug[j].hidden && visivel(sug[j])) return 'busca';
    var modais = doc.querySelectorAll('[aria-modal="true"]');
    for (var k = 0; k < modais.length; k++) if (modais[k] !== faixa && visivel(modais[k])) return 'janela';
    var a = doc.activeElement;
    if (a && a !== doc.body && a.matches && a.matches('input, textarea, select, [contenteditable="true"]')) return 'digitando';
    return '';
  }

  /* ---------------- mostrar ---------------- */
  var estado = { ativo: false, mostrado: false, formato: '', modo: '', gatilho: '', primeiro: 0, fim: false };
  function contexto() { return { formato: estado.formato, modo: estado.modo }; }
  function terminou(r) {
    if (estado.fim) return;
    estado.fim = true;
    if (r && r.salvou) emitir('carro_popup_aceito', contexto());
    else {
      lsGravar(K_FECHADO, String(Date.now()));
      emitir('carro_popup_fechado', { formato: estado.formato, modo: estado.modo, como: (r && r.motivo) || 'x' });
    }
  }
  function abrirJanela(origem) {
    var g = garagem();
    if (!g || !g.abrir) return;
    g.abrir({ modo: estado.modo, origem: origem, aoFechar: terminou });
  }

  function tentar(gatilho) {
    if (estado.mostrado || estado.fim) return;
    if (!estado.primeiro) { estado.primeiro = Date.now(); estado.gatilho = gatilho; }
    var s = situacao();
    if (!s || suprimido()) { parar(); return; }
    if (ocupado()) {
      if (Date.now() - estado.primeiro > DESISTE_MS) { parar(); return; }
      setTimeout(function () { tentar(gatilho); }, 1500);
      return;
    }
    estado.mostrado = true;
    estado.modo = s.modo;
    estado.formato = window.innerWidth >= COMPUTADOR ? 'cartao' : 'faixa';
    ssGravar(K_SESSAO, '1');
    parar();
    emitir('carro_popup_exibido', { formato: estado.formato, modo: estado.modo, gatilho: estado.gatilho });
    mostrarFaixa(s);
  }

  /* ---------------- faixa do celular ---------------- */
  var vigia = null;
  function nomeCarro(c) { var g = window.R130Motor; return g && g.rotulo ? g.rotulo(c) : String(c.model || '') + ' ' + (c.year || ''); }
  function base() {
    // Barras fixas embaixo (barra do celular, barra de compra do produto): a faixa fica acima delas.
    var h = window.innerHeight, maior = 0;
    doc.querySelectorAll('#mobile-bar, .r130-produto-fixo, .r130-mbar').forEach(function (el) {
      if (!visivel(el)) return;
      var r = el.getBoundingClientRect();
      if (r.bottom >= h - 2 && r.top < h) maior = Math.max(maior, h - r.top);
    });
    return maior;
  }
  function posicionar() { if (faixa) faixa.style.setProperty('--r130-cvt-base', Math.round(base()) + 'px'); }
  function esconderFaixa() {
    if (!faixa) return;
    faixa.classList.remove('is-visivel');
    faixa.hidden = true;
    clearInterval(vigia);
    doc.removeEventListener('keydown', aoTecla, true);
    doc.removeEventListener('click', aoClicarFora, true);
    window.removeEventListener('resize', posicionar);
    window.removeEventListener('scroll', posicionar);
  }
  function fecharFaixa(motivo) { esconderFaixa(); terminou({ salvou: false, motivo: motivo }); }
  function aceitarFaixa() { esconderFaixa(); abrirJanela('convite_faixa'); }
  function aoTecla(ev) {
    if (ev.key === 'Escape' && faixa && !faixa.hidden && !doc.querySelector('dialog[open]')) fecharFaixa('esc');
  }
  function aoClicarFora(ev) {
    if (!faixa || faixa.hidden || faixa.contains(ev.target)) return;
    var t = ev.target && ev.target.closest ? ev.target.closest('[data-r130-garagem-abrir], [data-r130-abrir-garagem]') : null;
    if (t) { esconderFaixa(); return; }   // abriu o "Meu carro" por outro botão: o convite cumpriu o papel
    if (doc.querySelector('dialog[open]')) return;
    fecharFaixa('fora');
  }
  function mostrarFaixa(s) {
    faixa = doc.querySelector('[data-r130-convite]');
    if (!faixa) { terminou({ salvou: false, motivo: 'sem_faixa' }); return; }
    var m = s.modo === 'completar' || s.modo === 'corrigir' ? s.modo : 'novo';
    var tit = faixa.getAttribute('data-tit-' + m) || '';
    if (s.carro) tit = tit.replace('[carro]', nomeCarro(s.carro));
    // Com o WhatsApp levando o carro (assets/r130-carro-wa.js), o texto "-wa": o vendedor recebe o carro e o motor.
    var wa = html.hasAttribute('data-r130-carro-wa');
    var attr = function (n) { return (wa && faixa.getAttribute(n + '-wa')) || faixa.getAttribute(n) || ''; };
    var txt = (estado.formato === 'faixa' && attr('data-txt-' + m + '-curto')) || attr('data-txt-' + m);   // cartão: texto inteiro
    faixa.querySelector('#r130-cvt-tit').textContent = tit;
    faixa.querySelector('#r130-cvt-txt').textContent = txt;
    faixa.querySelector('[data-r130-cvt-ok]').textContent = faixa.getAttribute('data-ok-' + m) || 'Informar meu carro';
    posicionar();
    faixa.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { faixa.classList.add('is-visivel'); }); });
    doc.addEventListener('keydown', aoTecla, true);
    setTimeout(function () { doc.addEventListener('click', aoClicarFora, true); }, 0);
    window.addEventListener('resize', posicionar);
    window.addEventListener('scroll', posicionar, { passive: true });
    // Outra janela abriu por cima, ou o carro foi salvo por outro caminho: a faixa sai da frente.
    vigia = setInterval(function () {
      if (!situacao()) { esconderFaixa(); return; }
      faixa.classList.toggle('is-escondida', !!ocupado() && ocupado() !== 'digitando');
      posicionar();
    }, 700);
  }

  /* ---------------- gatilhos ---------------- */
  var tempo = 0, relogio = null;
  function aoRolar() { if ((window.pageYOffset || 0) > window.innerHeight * ROLAGEM) tentar('rolagem'); }
  function parar() {
    clearInterval(relogio);
    window.removeEventListener('scroll', aoRolar);
  }
  function iniciar() {
    if (robo() || paginaBloqueada() || suprimido()) return;
    if (!garagem()) return;
    if (!situacao()) {
      // Carro completo: confere se ele está na lista da base; fora dela (e sem chassi), convida a corrigir.
      var c = garagem().carro();
      if (!c || temChassi() || !window.R130Motor || !window.R130Motor.existe) return;
      window.R130Motor.existe(c).then(function (sim) { if (!sim) { foraDaLista = c; comecar(); } });
      return;
    }
    comecar();
  }
  function comecar() {
    var faixaEl = doc.querySelector('[data-r130-convite]');
    if (faixaEl) {
      faixaEl.addEventListener('click', function (ev) {
        if (ev.target.closest('[data-r130-cvt-ok]')) aceitarFaixa();
        else if (ev.target.closest('[data-r130-cvt-fechar]')) fecharFaixa('x');
      });
    }
    relogio = setInterval(function () {
      if (doc.visibilityState === 'visible') tempo += 500;
      if (tempo >= ESPERA_MS) tentar('tempo');
    }, 500);
    window.addEventListener('scroll', aoRolar, { passive: true });
  }

  window.R130Convite = {
    // Para conferência: estado atual e regras (sem efeito no site).
    estado: function () { return { mostrado: estado.mostrado, formato: estado.formato, modo: estado.modo, ocupado: ocupado(),
      robo: robo(), bloqueada: paginaBloqueada(), suprimido: suprimido(), situacao: situacao() }; }
  };
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
